import { render } from "./Typography.vue?vue&type=template&id=a989227c&ts=true"
import script from "./Typography.vue?vue&type=script&lang=ts"
export * from "./Typography.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Work\\Picado\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__